import type { ElementType, ReactNode } from 'react'
import type { Localized } from '@/types'

interface CmsProps {
    as?: ElementType
    table: string
    id: string
    field: Localized
    className?: string
}

/** Renders one database text value and marks it so it can be edited straight from the preview. */
export const Cms = ({ as: Tag = 'span', table, id, field, className }: CmsProps): ReactNode => (
    <Tag data-mdlfy-cms={`${table}:${id}:${field.c}`} className={className}>
        {field.v}
    </Tag>
)
